import React from 'react';

import messages from './Messages';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';

interface IComponentState {}

interface IComponentProps {
  moveItems: IProviderItemViewWithData[];
  handleCancelMove: (id: number) => void;
}

class MoveClipboard extends React.Component<IComponentProps, IComponentState> {
  render() {
    if (this.props.moveItems === null) {
      return null;
    } else {
      return (
        <div className="row">
          <div className="col s12">
            <div className="card">
              {this.props.moveItems.map((item) => {
                return (
                  <div key={item.data.id} className="card-content">
                    <span>
                      {messages.cuted(item.data.name as string, item.data.type)}
                    </span>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.handleCancelMove(item.data.id);
                      }}
                      className="red-text left"
                      href="#!"
                    >
                      {messages.cancelMove}
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    }
  }
}
export default MoveClipboard;
